import * as React from "react";

function SvgCompleted(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.315 12.358L3.133 8.941a.506.506 0 010-.684l.643-.683a.437.437 0 01.642 0l2.219 2.393L11.58 4.64a.437.437 0 01.643 0l.643.684a.504.504 0 010 .683l-5.91 6.35a.437.437 0 01-.642 0z"
        fill="#3C7A79"
      />
    </svg>
  );
}

export default SvgCompleted;
